import { Strategy as StrategyType } from '../utils'
import Styles from './CustomizeTable.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { SocialRow } from './SocialRow'
import { VideosRow } from './VideosRow'
import { BlogRow } from './BlogRow'
import { NewsletterRow } from './NewsletterRow'
import { SelectedBlogPlatform, SelectedEmailPlatform } from 'types'

export interface CustomizeTableProps {
  strategy: StrategyType
  onUpdate: (strategy: StrategyType) => void
  selectedBlogPlatform: SelectedBlogPlatform
  setSelectedBlogPlatform: (platform: SelectedBlogPlatform) => void
  selectedEmailPlatform: SelectedEmailPlatform
  setSelectedEmailPlatform: (platform: SelectedEmailPlatform) => void
}

export const CustomizeTable = ({
  strategy,
  onUpdate,
  selectedBlogPlatform,
  setSelectedBlogPlatform,
  selectedEmailPlatform,
  setSelectedEmailPlatform,
}: CustomizeTableProps) => {
  const crosspostContentsCount = strategy.crosspost_contents.find((content) => content.type === 'post')?.count || 0
  const videoCrosspostContentsCount =
    strategy.video_crosspost_contents.find((content) => content.type === 'post')?.count || 0
  const seoContentsCount = strategy.seo_contents.find((content) => content.type === 'blog_post')?.count || 0
  const emailContentsCount = strategy.email_contents.find((content) => content.type === 'newsletter')?.count || 0

  return (
    <div className={Styles.customizeContent}>
      <div className={Styles.customizeHeaderRow}>
        <div className={Styles.customizeHeaderRowItem}>
          <Text variant="label" color="var(--dark-40)">
            Content Type
          </Text>
        </div>
        <div className={Styles.customizeHeaderRowItem}>
          <Text variant="label" color="var(--dark-40)">
            Channels
          </Text>
        </div>
        <div className={Styles.customizeHeaderRowItem}>
          <Text variant="label" color="var(--dark-40)">
            Posts per week
          </Text>
        </div>
      </div>
      <SocialRow
        strategy={strategy}
        onUpdate={onUpdate}
        isDisabled={videoCrosspostContentsCount === 0 && seoContentsCount === 0 && emailContentsCount === 0}
      />
      <VideosRow
        strategy={strategy}
        onUpdate={onUpdate}
        isDisabled={crosspostContentsCount === 0 && seoContentsCount === 0 && emailContentsCount === 0}
      />
      <BlogRow
        strategy={strategy}
        onUpdate={onUpdate}
        selectedBlogPlatform={selectedBlogPlatform}
        setSelectedBlogPlatform={setSelectedBlogPlatform}
        isDisabled={crosspostContentsCount === 0 && videoCrosspostContentsCount === 0 && emailContentsCount === 0}
      />
      <NewsletterRow
        strategy={strategy}
        onUpdate={onUpdate}
        selectedEmailPlatform={selectedEmailPlatform}
        setSelectedEmailPlatform={setSelectedEmailPlatform}
        isDisabled={crosspostContentsCount === 0 && videoCrosspostContentsCount === 0 && seoContentsCount === 0}
      />
    </div>
  )
}
